export const isEarlierThanCurrentMMYY = (targetMMYY: string): boolean => {
  const currentDate = new Date()

  const currentYear = currentDate.getFullYear() % 100
  const currentMonth = currentDate.getMonth() + 1

  // Split the target MMYY string into year and month
  const targetMonthStr = targetMMYY.slice(0, 2)
  const targetYearStr = targetMMYY.slice(2)

  // Convert the year and month strings to numbers
  const targetYear = parseInt(targetYearStr, 10)
  const targetMonth = parseInt(targetMonthStr, 10)

  // Check if the target year is earlier than the current year
  if (targetYear < currentYear) {
    return true
  }

  // Check if the target year is the same as the current year and if the target month is earlier
  if (targetYear === currentYear && targetMonth < currentMonth) {
    return true
  }

  return false
}
